<script lang="ts">
	import { CategoryGroup } from "@core/schema/CategoryGroup.js";
	import { getCataloguePath } from "@core/schema/paths/getCataloguePath.js";
	import { getCategoryGroupsPath } from "@core/schema/paths/getCategoryGroupsPath.js";
	import heroMobile from "../assets/final_photos/DSC_0325.jpg?webp&w=768&quality=65&imagetools";
	import heroTablet from "../assets/final_photos/DSC_0325.jpg?webp&w=1024&quality=65&imagetools";
	import heroLaptop from "../assets/final_photos/DSC_0325.jpg?webp&w=1536&quality=65&imagetools";
	import hero from "../assets/final_photos/DSC_0325.jpg?webp&w=1920&quality=65&imagetools";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./HomepageHero.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Link from "./common/Link.svelte";
	import Media from "./common/Media.svelte";
	import TextWithIcon from "./common/TextWithIcon.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
</script>

<svelte:head>
	<link rel="preload" as="image" type="image/webp" fetchpriority="high" href={heroMobile} media="(max-width: 767px)" />
	<link
		rel="preload"
		as="image"
		type="image/webp"
		fetchpriority="high"
		href={heroTablet}
		media="(min-width: 768px) and (max-width: 1023px)"
	/>
	<link
		rel="preload"
		as="image"
		type="image/webp"
		fetchpriority="high"
		href={heroLaptop}
		media="(min-width: 1024px) and (max-width: 1535px)"
	/>
	<link rel="preload" as="image" type="image/webp" fetchpriority="high" href={hero} media="(min-width: 1536px)" />
</svelte:head>

<section class="flex flex-1 flex-col gap-4 relative rounded-2xl justify-center container-whole">
	<div class="rounded-2xl inset-0">
		<div class="flex flex-col items-start rounded-2xl">
			<div class="relative inset-0 h-[37rem] sm:h-[34rem] md:h-[50rem] w-full">
				<Media
					height={0}
					width={1920}
					alt={translate("heading")}
					class="rounded-2xl object-cover h-full w-full opacity-90 brightness-[170%] shadow-lg grayscale"
					source={{ src: hero, type: "image/webp" }}
					sourcesets={{ "<md": heroMobile, "<lg": heroTablet, "<2xl": heroLaptop }}
					eager
				/>
				<div class="absolute inset-0 bg-zms-blue/80 rounded-2xl mix-blend-multiply"></div>
				<div
					class="absolute inset-0 bg-gradient-to-r opacity-30 from-zms-blue/90 via-zms-blue/80 to-zms-blue/60 rounded-2xl"
				></div>
			</div>
		</div>
		<div class="inset-0 absolute p-4 md:p-10 lg:p-16 flex flex-col justify-center lg:w-4/5 gap-4 md:gap-16 z-20">
			<div class="flex flex-col gap-4 md:gap-[2.5rem]">
				<h1
					class="font-medium text-[2.4rem]/[1.15] sm:font-normal md:text-[3.5rem]/[1.15] lg:text-[4rem]/[1.15] xl:text-3xl/[1.15]"
				>
					<Formatted text={translate("heading")} />
				</h1>
				<p class="text-white p-0 m-0 text-sm sm:text-base leading-relaxed md:text-lg/[1.4]">
					<Formatted text={translate("text")} />
				</p>
			</div>
			<div class="flex justify-start md:flex-row flex-col gap-4">
				<Link
					href={getCategoryGroupsPath(tenant, CategoryGroup.ProductionAndServices)}
					variant={ButtonVariant.OutlinedWithIcon}
					class="w-fit !text-sm xl:!text-md"
					><TextWithIcon><Formatted text={translate("ourServices")} /></TextWithIcon></Link
				>
				<Link
					href={getCataloguePath(tenant.locale)}
					variant={ButtonVariant.OutlinedWithIcon}
					class="w-fit hidden sm:block !text-sm xl:!text-md"
					><TextWithIcon><Formatted text={translate("contactUs")} /></TextWithIcon></Link
				>
				<Link
					href={getCataloguePath(tenant.locale)}
					variant={ButtonVariant.OutlinedWithIcon}
					class="w-fit sm:hidden !text-sm xl:!text-md"
					><TextWithIcon><Formatted text={translate("catalogue")} /></TextWithIcon></Link
				>
			</div>
		</div>
	</div>
</section>
